import { render } from "./Datatable.vue?vue&type=template&id=96b18e4a&ts=true"
import script from "./Datatable.vue?vue&type=script&lang=ts"
export * from "./Datatable.vue?vue&type=script&lang=ts"

import "./Datatable.vue?vue&type=style&index=0&id=96b18e4a&lang=scss"

import exportComponent from "/Users/thomas/Workspace/SushiEden/SushiEden.Admin.Vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__